<div id="no-records-screen">
  <mat-icon class="material-icons-outlined tooltip">{{ icon }}</mat-icon>
  <h2>{{ title }}</h2>
  <p>{{ description }}</p>
</div>
